import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type NetworksRemoveAssignmentMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.RemoveAssignmentInput;
}>;

export type NetworksRemoveAssignmentMutationResult = { __typename?: 'Mutation' } & {
  networksRemoveAssignment?: GraphQLTypes.Maybe<
    { __typename?: 'RemoveAssignmentPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const NetworksRemoveAssignmentDocument = gql`
  mutation networksRemoveAssignment($input: RemoveAssignmentInput!) {
    networksRemoveAssignment(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
